import { createSlice } from "@reduxjs/toolkit";
import collectionsInitialState from "@/components/CollectionsPage/redux/initialState";
import collectionsReducer from "@/components/CollectionsPage/redux/reducers";

const collectionsSlice = createSlice({
  name: "collections",
  initialState: collectionsInitialState,
  reducers: collectionsReducer,
});

export const { setLoading, setError, setCollectionData } = collectionsSlice.actions;

export default collectionsSlice.reducer;
